import React, { useEffect, useState } from "react";
import { Dropdown, Menu, MenuProps, message, Modal, Tooltip } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import ShopType from "@/enum/ShopType";
import { MenuInfo } from "rc-menu/es/interface";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import useCancelSplitOrderDialog from "../../dialogs/CancelSplitOrderDialog/useCancelSplitOrderDialog";
import useDownloadCustomization from "@/scenes/OrderManagement/components/BottomOperationBar/OtherOperationsButton/hooks/useDownloadCustomization";
import useAuthorityCheck from "@/hooks/useAuthorityCheck";
import Authority from "@/enum/Authority";
import DropShippingRefundStatus from "@/enum/DropShippingRefundStatus";
import useCancelDropshippingRefundRequest from "./hooks/useCancelDropshippingRefundRequest";
import { isDropshippingOrder, isOrderCanBeRefund } from "@/utils/dropShipping";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import ShopDTO from "@/dto/shop/ShopDTO";
import { useModalStore } from "@/hooks/Modal/hooks";
import SplitSingleOrderModal from "../../dialogs/SplitOrderDialog/SplitSingleOrderModal";
import ReprintEWaybillModal from "../../dialogs/ReprintEwaybillDialog/ReprintEWaybillModal";
import UpdateSellerRemarksModal from "../../dialogs/UpdateSellerRemarksDialog/UpdateSellerRemarksModal";
import SplitMergeParentOrderModal from "../../dialogs/SplitMergeParentOrderDialog/SplitMergeParentOrderModal";
import CancelEwaybillNoModal from "../../dialogs/CancelEwaybillNoDialog/CancelEwaybillNoModal";
import OrderOperationLogModal from "../../dialogs/OrderOperationLogDialog/OrderOperationLogModal";
import { PremiumFunctionType, usePremiumValidator } from "@/services/PremiumValidator";
import PremiumVersionIcon from "@/components/PremiumVersionIcon";
import OrderManagementStore, { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import SyncOrderProcessDialog from "../../dialogs/SyncOrderProcessDialog";
import { lockOrder } from "@/services/api/order";
import OrderTag from "@/enum/OrderTag";
import {
    SupplierShopTypes,
    hasBlackList,
    notShowCreateDecryptedOrderShopTypes,
    notShowCreateOrderShopTypes,
    showCreateEncryptedOrderShopTypes,
} from "@/utils/ShopUtils";
import SplitOrderMenuItem from "../../BottomOperationBar/OtherOperationsButton/components/SplitOrderMenuItem";
import OrderTagNameMap from "@/map/OrderTagNameMap";
import PaymentType from "@/enum/PaymentType";
import AddBlockListModal from "../../dialogs/AddBlockListModal";
import useDeleteBlacklistRequest from "./hooks/useDeleteBlacklistRequest";
import { hasLocalConsigneeInfo, isBlacklistOrder } from "@/utils/OrderUtils";
import AppVersion from "@/enum/AppVersion";
import { disabledSplitTags } from "../../dialogs/SplitOrderDialog/services";
import useCancelDropshippingOrdersClick from "../../BottomOperationBar/OtherOperationsButton/hooks/useCancelDropshippingOrdersClick";
import TbUpdateSellerRemarksModal from "../../dialogs/TbUpdateSellerRemarksModal";
import CreateEncryptedManualOrderModal from "@/scenes/OrderSearch/components/SearchOrderTable/components/CreateEncryptedManualOrderModal";
import { useHistory } from "react-router";
import OrderStatus from "@/enum/OrderStatus";
import BatchRefundDropShippingOrderModal from "../../dialogs/BatchRefundDropShippingOrderModal";
import { DropShippingRefundResult } from "@/services/api/dropShipping/refund";
import { isAnyOrderWithTaoTianReissueTag } from "@/utils/OrderTagUtils";
import UpdateManualOrderItemModal from "../../dialogs/UpdateManualOrderItemModal";
import { openCreateDecryptedManualOrderModal } from "@/scenes/OrderSearch/components/SearchOrderTable/components/CreateDecryptedManualOrderModal/openCreateDecryptedManualOrderModal";
import CopyManualOrderModal from "../../dialogs/CopyManualOrderModal";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { MenuDivider, MenuItem, MenuItemGroup, SubMenu, buildMenuItems } from "@/utils/antdItems";

enum OtherOperationType {
    /**创建千牛任务 */
    QN_CREATE_TASK = "QN_CREATE_TASK",
    /**千牛关闭订单 */
    QN_CLOSE_ORDER = "QN_CLOSE_ORDER",
    /**更新卖家备注 */
    UPADTE_SELLER_REMARKS = "UPADTE_SELLER_REMARKS",
    /**重打电子面单 */
    REPRINT_EWAYBILL = "REPRINT_EWAYBILL",
    /** 修改商品 */
    UPDATE_MANUAL_ORDER_ITEM = "UPDATE_MANUAL_ORDER_ITEM",
    /** 复制手工订单 */
    COPY_MANUAL_ORDER = "COPY_MANUAL_ORDER",

    /** 查看/打印底单 */
    REPRINT_ORIGINAL_ADDRESS_EWAYBILL = "REPRINT_ORIGINAL_ADDRESS_EWAYBILL",
    /**回收电子面单 */
    CANCEL_EWAYBILL_NO = "CANCEL_EWAYBILL_NO",
    /**重新同步订单 */
    RESYNC_ORDER = "RESYNC_ORDER",
    /** 供货商取消订单  */
    SUPPLIER_CANCEL_ORDER = "SUPPLIER_CANCEL_ORDER",
    /**拆分合并订单 */
    SPLIT_MERGE_PARENT_ORDER = "SPLIT_MERGE_PARENT_ORDER",
    /**查看订单操作日志 */
    VIEW_ORDER_LOG = "VIEW_ORDER_LOG",
    /**拆分订单 */
    SPLIT_ORDER = "SPLIT_ORDER",
    /**取消拆分订单 */
    CANCEL_SPLIT_ORDER = "CANCEL_SPLIT_ORDER",

    /* 下载定制图 */
    DOWNLOAD_CUSTOMIZATION = "DOWNLOAD_CUSTOMIZATION",

    /** 退回代发订单 */
    REFUND_DROPSHIPPING_ORDER = "REFUND_DROPSHIPPING_ORDER",

    /** 撤销代发退款  */
    WITHDRAW_DROPSHIPPING_REFUND = "WITHDRAW_DROPSHIPPING_REFUND",

    /** 锁定订单 */
    LOCK_ORDER = "LOCK_ORDER",

    /** 添加黑名单 */
    ADD_TO_BLACK_LIST = "ADD_TO_BLACK_LIST",

    /** 删除黑名单 */
    DELETE_BLACK_LIST = "DELETE_BLACK_LIST",

    /** 创建明文订单 */
    CREATE_DECRYPTED_ORDER = "CREATE_DECRYPTED_ORDER",

    /** 创建密文订单 */
    CREATE_ENCRYPTED_ORDER = "CREATE_ENCRYPTED_ORDER",
}

function buildSplitOrderMenuItem(shopMapping: Map<number, ShopDTO>, order: OrderDTO, tab: OrderTab) {
    const isDropShipping = isDropshippingOrder(order);

    if (isDropShipping) return null;

    const flag = order.orderItems?.length > 1 && order.mergeSplitStatus !== OrderMergeSplitStatus.MERGE_PARENT;

    const flag2 = [OrderTab.PENDING_SHIPMENT, OrderTab.PENDING_SHIPMENT_REFUNDING].includes(tab);

    if (flag && flag2) {
        return (
            <MenuItem key={OtherOperationType.SPLIT_ORDER}>
                <SplitOrderMenuItem shop={shopMapping.get(order.shopId)} />
            </MenuItem>
        );
    }

    return null;
}

const notAllowedSyncOrderShopType = [ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL];

function shouldShowResyncButton(order: OrderDTO, shopType: ShopType, orderManagementStore: OrderManagementStore) {
    if (notAllowedSyncOrderShopType.includes(shopType)) return false;

    /**
     * FHY-2259
     * 供货商视角下
     * 是否为代理商已取消的并且是拆分订单
     */
    const isCancelAndRetailerSplitChildOrder =
        order?.supplierDropShippingInfo?.retailerOrderMergeSplitStatus === OrderMergeSplitStatus.SPLIT_CHILD &&
        order.status === OrderStatus.CANCELED;
    if (isCancelAndRetailerSplitChildOrder) return false;

    const isReissueOrder = isAnyOrderWithTaoTianReissueTag([order]);
    if (isReissueOrder) return false;

    let isManualPushOrder = false;
    if (order.supplierDropShippingInfo) {
        const retailerShopType = orderManagementStore?.supplierPartnershipsStore?.retailerPartnershipMap?.get(
            order.supplierDropShippingInfo.retailerShopId,
        )?.shopType;

        isManualPushOrder = notAllowedSyncOrderShopType.includes(retailerShopType);
    }
    if (isManualPushOrder) return false;

    return true;
}

type DropdownOverlayMenuProps = MenuProps & OrderOperationMenuProps;

const DropdownOverlay = observer(
    React.forwardRef<any, DropdownOverlayMenuProps>((props, ref) => {
        const { order, isQianniu, shopType, isSupplierShop, tab, onClick: onMenuClick, ...otherProps } = props;

        const modalStore = useModalStore();
        const orderManagementStore = useOrderManagementStore();
        const globalStore = useGlobalStore();
        const { validate: premiumValidate } = usePremiumValidator();
        const [showDeleteBlacklistBtn, setShowDeleteBlacklistBtn] = useState(false);

        const history = useHistory();

        useEffect(() => {
            if (isBlacklistOrder(order)) {
                (async () => {
                    await globalStore.ensureShopSetting([order.shopId]);

                    if (globalStore.shopSettingMapping.get(order.shopId)?.appVersion === AppVersion.PREMIUM) {
                        setShowDeleteBlacklistBtn(true);
                    }
                })();
            } else {
                setShowDeleteBlacklistBtn(false);
            }
        }, [order.tags]);

        const onRefresh = () => {
            orderManagementStore.fetchOrders(order.shopId, tab);
        };

        const onRefreshOrderAndListCount = () => {
            onRefresh();

            orderManagementStore.getOrderListCount();
        };

        const cancelDropshippingOrders = useCancelDropshippingOrdersClick(onRefreshOrderAndListCount);

        const { onOpen: onOpenCancelSplitOrderModal } = useCancelSplitOrderDialog(onRefresh);

        const hasCustomization = order.orderItems?.some((orderItem) => orderItem?.customizationInfo);

        const { handleDownload } = useDownloadCustomization(() => [order]);

        const { hasAuthority, openAuthorityModal } = useAuthorityCheck(Authority.ROLE_DROP_SHIPPING_REFUND_MANAGEMENT);

        const cancelDropshippingRefundRequest = useCancelDropshippingRefundRequest(order);

        const deleteBlacklist = useDeleteBlacklistRequest();

        function handleRefundDropShippingOrderComplete(refundResults: DropShippingRefundResult[]) {
            const refundResult = refundResults.find((result) => result.retailerOrderId === order.id);

            if (!refundResult) return;

            const retailerDropShippingInfo = refundResult.retailerDropShippingInfo;

            orderManagementStore.table.updateOrder(order.id, {
                retailerDropShippingInfo,
            });
        }

        const handleMenuClick = async (info: MenuInfo) => {
            onMenuClick?.(info);

            const { key } = info;

            if (key === OtherOperationType.CANCEL_EWAYBILL_NO) {
                modalStore.openModal(CancelEwaybillNoModal, {
                    order,
                });
            } else if (key === OtherOperationType.UPADTE_SELLER_REMARKS) {
                if (shopType === ShopType.TAOBAO) {
                    modalStore.openModal(TbUpdateSellerRemarksModal, {
                        order,
                    });
                } else {
                    modalStore.openModal(UpdateSellerRemarksModal, {
                        order,
                    });
                }
            } else if (key === OtherOperationType.VIEW_ORDER_LOG) {
                modalStore.openModal(OrderOperationLogModal, {
                    order,
                });
            } else if (key === OtherOperationType.RESYNC_ORDER) {
                // 如果是供货商店铺,并且该订单的代理商店铺已过期,给出提示
                if (isSupplierShop && order?.supplierDropShippingInfo?.retailerShopTokenExpired) {
                    const retailerShopId = order.supplierDropShippingInfo?.retailerShopId;

                    const partnership =
                        orderManagementStore.supplierPartnershipsStore.retailerPartnershipMap.get(retailerShopId);

                    Modal.error({
                        title: "温馨提示",
                        content: `代理商店铺【${
                            partnership?.alias || partnership?.name
                        }】店铺授权过期，请联系代理商登录发货易，您再尝试重新同步`,
                    });
                    return;
                }

                modalStore.openModal(SyncOrderProcessDialog, {
                    shopId: order.shopId,
                    orderSyncType: "RESYNC_ONE",
                    order,
                });

                try {
                    const shop = globalStore.shopMapping.get(order.shopId);
                    collectEvent(DataTrackEvent.RESYNC_ORDER, {
                        shop_id: shop.id,
                        shop_name: shop.name,
                        shop_type: ShopTypeNameMap[shop.type],
                        order_count: 1,
                    });
                } catch {}
            } else if (key === OtherOperationType.REPRINT_EWAYBILL) {
                modalStore.openModal(ReprintEWaybillModal, {
                    order,
                    isFromReprint: true,
                });
            } else if (key === OtherOperationType.UPDATE_MANUAL_ORDER_ITEM) {
                modalStore.openModal(UpdateManualOrderItemModal, {
                    order,
                    onSuccess: onRefresh,
                });
            } else if (key === OtherOperationType.COPY_MANUAL_ORDER) {
                modalStore.openModal(CopyManualOrderModal, {
                    order,
                    onSuccess: onRefresh,
                });
            } else if (key === OtherOperationType.REPRINT_ORIGINAL_ADDRESS_EWAYBILL) {
                history.push({
                    pathname: "/features/ewaybillSnapshot",
                    search: `shopId=${order.shopId}&orderOriginalId=${order.originalId}`,
                });
            } else if (key === OtherOperationType.SPLIT_MERGE_PARENT_ORDER) {
                modalStore.openModal(SplitMergeParentOrderModal, {
                    order,
                    onSuccess: onRefresh,
                });
            }
            // 拆分订单
            else if (key === OtherOperationType.SPLIT_ORDER) {
                let disabledSplitTag: OrderTag;

                if (order.paymentType === PaymentType.COD) {
                    Modal.error({ title: "货到付款订单无法拆分" });

                    return;
                }

                if (order.tags) {
                    for (const tag of order.tags) {
                        if (disabledSplitTags.includes(tag)) {
                            disabledSplitTag = tag;

                            break;
                        }
                    }
                }

                if (disabledSplitTag) {
                    Modal.error({ title: `"${OrderTagNameMap[disabledSplitTag]}"订单无法拆分` });

                    return;
                }

                if (order.tags?.includes(OrderTag.TAOTIAN_SHIP_BY_SF_JC)) {
                    Modal.info({
                        content:
                            "选择的加价发顺丰订单一般情况不需要拆分，如订单不同商品从不同仓库发货，可以进行拆分打印发货",
                        onOk() {
                            modalStore.openModal(SplitSingleOrderModal, {
                                order,
                                onSuccess: onRefresh,
                            });
                        },
                        okText: "继续",
                        keyboard: false,
                    });
                } else {
                    modalStore.openModal(SplitSingleOrderModal, {
                        order,
                        onSuccess: onRefresh,
                    });
                }
            }
            // 取消拆分订单
            else if (key === OtherOperationType.CANCEL_SPLIT_ORDER) {
                onOpenCancelSplitOrderModal(order);
            } else if (key === OtherOperationType.REFUND_DROPSHIPPING_ORDER) {
                if (!hasAuthority) {
                    openAuthorityModal();

                    return;
                }

                modalStore.openModal(BatchRefundDropShippingOrderModal, {
                    orders: [order],
                    onComplete: handleRefundDropShippingOrderComplete,
                });
            } else if (key === OtherOperationType.DOWNLOAD_CUSTOMIZATION) {
                handleDownload();
            } else if (key === OtherOperationType.WITHDRAW_DROPSHIPPING_REFUND) {
                cancelDropshippingRefundRequest.runAsync();
            } else if (key === OtherOperationType.LOCK_ORDER) {
                // 代发订单，并且还没有退款的
                if (order.retailerDropShippingInfo && !order.retailerDropShippingInfo.refundStatus) {
                    const shouldNext = await new Promise<boolean>((yes) => {
                        Modal.confirm({
                            width: 466,
                            title: "选择的订单中有代发订单，如挂起不发货，可以先退回代发订单再操作或联系供货商说明，以免供货商发货",
                            content: (
                                <div className="mt20">
                                    <a
                                        className="mr5"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            const shouldNext = globalStore.checkUserAuthority(
                                                Authority.ROLE_DROP_SHIPPING_REFUND_MANAGEMENT,
                                            );

                                            if (!shouldNext) {
                                                return;
                                            }

                                            modalStore.openModal(BatchRefundDropShippingOrderModal, {
                                                orders: [order],
                                                onComplete: handleRefundDropShippingOrderComplete,
                                            });
                                        }}
                                    >
                                        退回代发订单
                                    </a>
                                    <span className="text-gray text-small">点击可直接退回代发订单，在操作挂起</span>
                                </div>
                            ),
                            okText: "取消",
                            onOk() {
                                yes(false);
                            },
                            cancelText: "继续锁定",
                            onCancel() {
                                yes(true);
                            },
                            afterClose() {
                                yes(false);
                            },
                        });
                    });

                    if (!shouldNext) {
                        return;
                    }
                }

                await lockOrder(order.shopId, [order]);

                message.success("已锁定");

                const newTags = order?.tags || [];

                newTags.push(OrderTag.LOCKED);

                orderManagementStore.table.updateOrder(order.id, { tags: newTags });

                orderManagementStore.table.unselectOrder(order.id);

                orderManagementStore.table.orderLockStore.manualLockOrderIdMapping.set(order.id, true);

                const shop = globalStore.shopMapping.get(order.shopId);
                collectEvent(DataTrackEvent.LOCK_ORDER, {
                    shop_id: shop.id,
                    shop_name: shop.name,
                    shop_type: ShopTypeNameMap[shop.type],
                    order_count: 1,
                    context: OrderTagNameMap[tab],
                });
            } else if (key === OtherOperationType.ADD_TO_BLACK_LIST) {
                const flag = await premiumValidate({ type: PremiumFunctionType.BLACKLIST, shopId: order.shopId });

                if (flag) {
                    modalStore.openModal(AddBlockListModal, { order, onSuccess: onRefresh });
                }
            } else if (key === OtherOperationType.DELETE_BLACK_LIST) {
                deleteBlacklist(order);
            } else if (key === OtherOperationType.SUPPLIER_CANCEL_ORDER) {
                cancelDropshippingOrders([order]);
            } else if (key === OtherOperationType.CREATE_DECRYPTED_ORDER) {
                openCreateDecryptedManualOrderModal(globalStore, modalStore, order, "订单列表");
            } else if (key === OtherOperationType.CREATE_ENCRYPTED_ORDER) {
                modalStore.openModal(CreateEncryptedManualOrderModal, {
                    order,
                    eventContext: "订单列表",
                });
            }
        };

        const info = order.retailerDropShippingInfo;

        const showRefund = isOrderCanBeRefund(order);

        const isRefund = !!info && info.refundStatus === DropShippingRefundStatus.PENDING_REFUND;

        const showResyncBtn = shouldShowResyncButton(order, shopType, orderManagementStore);

        return (
            <Menu
                {...otherProps}
                onClick={handleMenuClick}
                ref={ref}
                items={buildMenuItems(
                    <>
                        {isQianniu ? <MenuItem key={OtherOperationType.QN_CREATE_TASK}>创建千牛任务</MenuItem> : null}
                        {isQianniu && order.status === "PENDING_PAYMENT" ? (
                            <MenuItem key={OtherOperationType.QN_CLOSE_ORDER}>关闭订单</MenuItem>
                        ) : null}

                        {!isSupplierShop && (
                            <MenuItem key={OtherOperationType.UPADTE_SELLER_REMARKS}>修改卖家备注、旗帜</MenuItem>
                        )}
                        <MenuItem key={OtherOperationType.REPRINT_EWAYBILL}>用旧电子面单号重打</MenuItem>
                        {[ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL].includes(shopType) ? (
                            <>
                                <MenuItem key={OtherOperationType.UPDATE_MANUAL_ORDER_ITEM}>修改商品</MenuItem>
                                <MenuItem key={OtherOperationType.COPY_MANUAL_ORDER}>复制订单</MenuItem>
                            </>
                        ) : null}
                        <MenuItem key={OtherOperationType.REPRINT_ORIGINAL_ADDRESS_EWAYBILL}>查看/打印底单</MenuItem>
                        <MenuItem key={OtherOperationType.CANCEL_EWAYBILL_NO}>查看/回收电子面单号</MenuItem>
                        <MenuItem key={OtherOperationType.LOCK_ORDER}>锁定订单</MenuItem>
                        {buildSplitOrderMenuItem(globalStore.shopMapping, order, tab)}

                        {order.mergeSplitStatus === OrderMergeSplitStatus.SPLIT_CHILD ? (
                            <MenuItem key={OtherOperationType.CANCEL_SPLIT_ORDER}>
                                <span>取消拆分订单</span>
                                <PremiumVersionIcon />
                            </MenuItem>
                        ) : null}

                        {showResyncBtn ? (
                            <MenuItem key={OtherOperationType.RESYNC_ORDER}>重新同步此订单</MenuItem>
                        ) : null}

                        {!notShowCreateOrderShopTypes.includes(shopType) ? (
                            <SubMenu key="createOrder" title="创建手工/售后单">
                                {!notShowCreateDecryptedOrderShopTypes.includes(shopType) ? (
                                    <MenuItem key={OtherOperationType.CREATE_DECRYPTED_ORDER}>
                                        <Tooltip title="创建明文订单时，加密订单会自动解密，会消耗1次解密次数">
                                            <span>创建明文订单</span>
                                        </Tooltip>
                                    </MenuItem>
                                ) : null}
                                {showCreateEncryptedOrderShopTypes.includes(shopType) &&
                                !hasLocalConsigneeInfo(order.consignee) ? (
                                    <MenuItem key={OtherOperationType.CREATE_ENCRYPTED_ORDER}>创建密文订单</MenuItem>
                                ) : null}
                            </SubMenu>
                        ) : null}

                        {SupplierShopTypes.includes(shopType) ? (
                            <MenuItem key={OtherOperationType.SUPPLIER_CANCEL_ORDER}>退回/取消订单</MenuItem>
                        ) : null}

                        {order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT ? (
                            <MenuItem key={OtherOperationType.SPLIT_MERGE_PARENT_ORDER}>取消合并订单</MenuItem>
                        ) : null}

                        {/* 待发货下的 代理商的代销订单专用 */}
                        {/* {order.retailerDropShippingInfo?.processingStatus === DropShippingProcessingStatus.PROCESSING &&
    order.status === OrderStatus.PENDING_SHIPMENT ? (
        <MenuItem key={OtherOperationType.APPOINT_SHIPPING}>预约单号发货</MenuItem>
    ) : null} */}

                        {hasCustomization && (
                            <MenuItem key={OtherOperationType.DOWNLOAD_CUSTOMIZATION}>下载定制图</MenuItem>
                        )}

                        {showRefund && (
                            <MenuItem key={OtherOperationType.REFUND_DROPSHIPPING_ORDER}>退回代发订单</MenuItem>
                        )}

                        {isRefund && (
                            <MenuItem key={OtherOperationType.WITHDRAW_DROPSHIPPING_REFUND}>撤销代发退款</MenuItem>
                        )}

                        <MenuItem key={OtherOperationType.VIEW_ORDER_LOG}>查看操作日志</MenuItem>

                        {hasBlackList(shopType) && !isBlacklistOrder(order) ? (
                            <MenuItem key={OtherOperationType.ADD_TO_BLACK_LIST}>
                                <span>添加黑名单</span>
                                <PremiumVersionIcon />
                            </MenuItem>
                        ) : null}

                        {showDeleteBlacklistBtn ? (
                            <MenuItem key={OtherOperationType.DELETE_BLACK_LIST}>删除黑名单</MenuItem>
                        ) : null}
                    </>,
                )}
            />
        );
    }),
);

// 单个订单操作菜单

interface OrderOperationMenuProps {
    order: OrderDTO;

    tab?: OrderTab;

    isQianniu?: boolean;

    shopType?: ShopType;

    isSupplierShop?: boolean;
}

const OrderOperationMenu: React.FC<OrderOperationMenuProps> = function (props) {
    const [shouldRenderOverlay, setShouldRenderOverlay] = useState(false);

    function handleVisibleChange(visible: boolean) {
        if (visible) {
            setShouldRenderOverlay(true);
        }
    }

    return (
        <div className="order-operation-menu">
            <Dropdown
                menu={{ items: [] }}
                popupRender={() => {
                    // DropdownOverlay 内部会初始化多个 store、modal 和业务处理函数，第一次打开菜单时再挂载。
                    if (!shouldRenderOverlay) {
                        return <Menu />;
                    }

                    return <DropdownOverlay {...props} />;
                }}
                placement="bottomLeft"
                trigger={["click"]}
                onOpenChange={handleVisibleChange}
                destroyOnHidden
            >
                <a
                    href="#"
                    onClick={(event) => {
                        event.preventDefault();
                    }}
                >
                    <span className="inline-block">操作</span>
                    <CaretDownOutlined style={{ fontSize: 12, verticalAlign: "middle" }} />
                </a>
            </Dropdown>
        </div>
    );
};

export default observer(OrderOperationMenu);
